<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-podium</v-icon>{{$t('profile.score.tools')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfileToolForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfileToolForm from '../../components/profiletool/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfileTool';

const { mapFields } = createHelpers({
  getterType: 'profiletool/getField',
  mutationType: 'profiletool/updateField'
});

export default {
  name: 'ProfileToolCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileToolForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profiletool', ['create', 'reset'])
  }
};
</script>
